/**
 * @generated SignedSource<<2545fe80bb5d89c1d7fa04e3d9d35741>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfoLink_viewer$data = {
  readonly buyerItemConversation?: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedShippingInfoLink_viewer";
};
export type PdpSharedShippingInfoLink_viewer$key = {
  readonly " $data"?: PdpSharedShippingInfoLink_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfoLink_viewer",
  "selections": [
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "Conversation",
          "kind": "LinkedField",
          "name": "buyerItemConversation",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8eab7b42fce448dff41538cf9ddcb35c";

export default node;
